import React, { useEffect, useState } from "react";
import TokenContract from '../getAbis/token.json'
import StakeContract from '../getAbis/stake.json'
import { getUsdPrice } from "../getUsdPrice";
import Web3EthContract from "web3-eth-contract";
import { useWeb3React } from "@web3-react/core";
import { providerURL } from "../walletConnect/utils";

const Price = () => {
  const { library, connector, active } = useWeb3React()
  const [price, setPrice] = useState(0);
  const [marketCap, setMarketCap] = useState(0);
  const [totalStakers, setTotalStakers] = useState(0);
  const [circulatingSupplyValue, setCirculatingSupplyValue] = useState(0);
  const [totalStaked, setTotalStaked] = useState(0);
  useEffect(() => {
    const getData = async () => {
      const { ethereum } = window;
      if (active) {
        Web3EthContract.setProvider(library);
      } else {
        let provider = providerURL()
        Web3EthContract.setProvider(provider);
      }
      console.log("library here ", library)
      console.log("active here ", active)
      console.log("connector here ", connector)
      const token_contract = new Web3EthContract(TokenContract.abi, TokenContract.TOKEN_ADDRESS);
      const stake_contract = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);

      let usdPrice = await getUsdPrice()
      setPrice(usdPrice)
      let totalSupply = await token_contract.methods.totalSupply().call() / 10 ** 18
      let owner = await token_contract.methods.owner().call()
      let ownerBalance = await token_contract.methods.balanceOf(owner).call() / 10 ** 18
      let circulatingSupply = totalSupply - ownerBalance
      setCirculatingSupplyValue(circulatingSupply)
      setMarketCap(usdPrice * circulatingSupply)

      setTotalStakers(await stake_contract.methods.totalStaker().call())
      setTotalStaked(await stake_contract.methods.totalStaked().call() / 10 ** 18)
    }
    getData()
  }, [active]);

  return (
    <>
      <section className="priceSection padSection text-center">
        <div className="container">
          <h2>The Grays <span>Token Stake</span></h2>
          <div className="small_boxes">
            <div className="row">
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>${parseFloat(price).toFixed(4)}</h4>
                    <p>Price</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>${parseFloat(marketCap).toFixed(4)}</h4>
                    <p>Market Cap</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>N/A</h4>
                    <p>Market rank</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>N/A</h4>
                    <p>Market dominance</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>N/A</h4>
                    <p>Holders</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>{totalStakers}</h4>
                    <p>Stakers</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>N/A</h4>
                    <p>Total value locked</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>{parseFloat(circulatingSupplyValue).toFixed(4)}</h4>
                    <p>Circulating supply</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>{parseFloat(totalStaked).toFixed(4)}</h4>
                    <p>Staked supply</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="snB">
                  <div className="snIN">
                    <h4>N/A</h4>
                    <p>Share price increase</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Price;